import React from 'react'

import { DesktopPagination, DesktopPaginationProps } from './desktop'

export const getPaginationPages = (totalPages: number, currentPage: number, windowSize: number = 3) => {
  const pages: (number | string)[] = []

  if (totalPages <= windowSize + 4) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
    return pages
  }

  pages.push(1)

  let start = Math.max(2, currentPage - Math.floor(windowSize / 2))
  let end = Math.min(totalPages - 1, currentPage + Math.floor(windowSize / 2))

  if (currentPage <= Math.ceil(windowSize / 2)) {
    start = 2
    end = windowSize + 1
  }

  if (currentPage >= totalPages - Math.floor(windowSize / 2)) {
    start = totalPages - windowSize
    end = totalPages - 1
  }

  if (start > 2) {
    pages.push('...')
  }

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  if (end < totalPages - 1) {
    pages.push('...')
  }

  pages.push(totalPages)

  return pages
}

export type PaginationProps = DesktopPaginationProps & {
  isHidden?: boolean
}

export const Pagination: React.FC<PaginationProps> = props => {
  const isDefaultHidden = !props.pagination.hasNext && !props.pagination.hasPrevious

  if (props.isHidden ?? isDefaultHidden) {
    return null
  }

  return <DesktopPagination {...props} />
}
